export default {
  sales: [],
  loading: false
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/dynamic-matrix/state.js